
  import { Component, Prop, Watch, Emit } from 'vue-property-decorator'
  import { plainToInstance } from 'class-transformer'
  import BaseForm from '@/components/forms/view/BaseForm.vue'
  import { Form } from '@/entities/public/Resource/metadata'
  import { fixAmountFormatted, parseToNumber, stringifySafe } from '@/utils/general'
  import GFiles from '@/components/core/files/GFiles.vue'
  import { Stock } from '@/entities/sales'
  import { ImportStockView } from '@/components/config/importStock/ImportStockView'
  import GDatePicker from '@/components/core/input/GDatePicker.vue'
  import GCostField from '@/components/core/input/GCostField.vue'
  import ImportAttribute from '@/components/config/importStock/ImportAttribute.vue'
  import { RULES } from '@/components/forms'
  import axios from 'axios'
  import { updateJWT } from '@/store/resources/form/actions'
  import CreateVersion from '@/components/config/importStock/CreateVersion.vue'
  import GAlert from '@/components/core/alert/GAlert.vue'
  import _ from 'lodash'
  import { Debounce } from '@/utils/decorators'
  import GPpu from '@/components/core/input/GPpu.vue'

@Component({
  components: { GFiles, GDatePicker, GCostField, ImportAttribute, BaseForm, CreateVersion, GAlert, GPpu },
  methods: { fixAmountFormatted },
})
  export default class SupervisorAddStockForm extends ImportStockView {
  @Prop({ type: Boolean, default: false }) readonly isConfig!: boolean
  @Prop({ type: Object, default: null }) readonly editRecord!: any
  @Prop({ type: Boolean, default: false }) readonly cleanForm!: boolean

    title = 'IMPORTACIÓN'
    showDetail = false
    displaySii= false
    stock: Stock = plainToInstance(Stock, {})
    valid = false
    loadingForm = false
    fieldRequired = RULES.isRequired
    isFormValid = false
    ppuRules = [
      v => !!v || 'Campo requerido',
    ]

    // Headers para la tabla de propietarios
    ownerHeaders = [
      { text: 'Nombre', value: 'name', sortable: false },
      { text: 'RUT', value: 'uid', sortable: false },
      { text: 'Tipo', value: 'type', sortable: false },
    ]

    // Variables para el componente de crear versiones
    showCreateVersionDialog = false
    suggestedVersion = ''

    plateAlert = {
      open: false,
      title: '',
    }

    cavAlert = {
      open: false,
      title: '',
    }

    successAlert = {
      open: false,
      title: '',
    }

    errorAlert = {
      open: false,
      title: '',
    }

    formData = {
      cav: [],
      ppu: '',
      year: null,
      brand: {
        match: null,
        data: [],
      },
      model: {
        match: null,
        data: [],
      },
      version: {
        match: null,
        data: [],
      },
      traction: { value: '' },
      transmission: { value: '' },
      fuel: { value: '' },
      owner: [],
      personType: [],
      uid: [],
      acquisitionType: null,
      date: null,
      key: '',
      keyErrorMessage: '',
      mileage: null,
      owners: 1,
      purchasePrice: null,
      priceList: null,
      discount: null,
      renewalBonus: null,
      renewalBonusErrorMessage: '',
      renewalBonusWarningMessage: '',
      priceListErrorMessage: '',
      discountErrorMessage: '',
      discountWarningMessage: '',
      generation: null,
      checkAttributes: true,
      idVersionYear: null,
      idGeneration: null,
      cavData: null,
      cavErrorMessages: [],
      id: this.getGenerateRandomKey(),
      cavSerialization: null,
    }

    fields = {
      cav: {
        properties: {
          label: '',
          accept: '',
          fileTypeId: null,
          multiple: false,
          name: '',
          appendOuterIcon: '',
        },
      },
    }

    metadata = {}
    metadataCollection = {}

    get hasErrors () {
      const { formData } = this

      if (formData.renewalBonusWarningMessage?.length) {
        return true
      }

      if (!formData.cavErrorMessages || !Array.isArray(formData.cavErrorMessages)) {
        return Boolean(formData.keyErrorMessage?.length ||
               formData.renewalBonusErrorMessage?.length ||
               formData.discountErrorMessage?.length)
      }

      // Solo excluimos los mensajes de versión si es necesario, pero consideramos todos los demás
      // Incluimos explícitamente los errores de patente, año, marca y modelo
      const hasCavErrors = formData.cavErrorMessages.some(error =>
        !error.includes('Versión:') ||
        error.includes('Patente:') ||
        error.includes('Año:') ||
        error.includes('Marca:') ||
        error.includes('Modelo:')
      )

      return Boolean(formData.keyErrorMessage?.length ||
             formData.renewalBonusErrorMessage?.length ||
             formData.discountErrorMessage?.length ||
             hasCavErrors)
    }

    get disableFormState () {
      return !this.isFormValid || this.hasErrors
    }

  async mounted () {
      this.resetForm()
      await this.setMetadata()
      const { title, metadataCollection } = this

      if (!this.isBreadCrumbPresent(title)) {
        this.setFormCrumbs(metadataCollection, title, false)
      }

      this.displayDetail()
      await this.loadCavProperties()

      // Si se recibe un registro para editar, inicializar el formulario con sus datos
      if (this.editRecord) {
        // Clonar el objeto para evitar mutaciones externas
        this.formData = _.cloneDeep(this.editRecord)
        this.handleBrandChange()
        this.formData.model.match = _.cloneDeep(this.editRecord.model.match)
        await this.handleModelChange()
        this.formData.version.match = _.cloneDeep(this.editRecord.version.match)
        await this.handleVersionChange()
        this.formData.checkAttributes = true
      }
    }

    async setMetadata () {
      const { metadata } = this.getForm('Stock', 'supervisor_add_stock')
      const { form } = metadata as Form
      this.title = form.title
      this.metadataCollection = metadata
    }

    displayDetail () {
      const { stock, metadataCollection } = this

      this.metadata = {
        data: stock,
        metadata: metadataCollection,
      }

      this.showDetail = Boolean(stock.id)
    }

    async loadCavProperties () {
      const fileInfo = await this.fetchData({
        query: { name: 'find', model: 'FileParameter' },
        filter: { process: { table_name: { _eq: 'negotiation' } } },
      })

      this.setProperties(fileInfo, 'cav', 'cav')
    }

    setProperties (fileInfo, fileTypeName, fieldKey) {
      if (!fileInfo?.length) return
      const info = fileInfo.find(fileParameter => fileParameter.name === fileTypeName)
      if (info) {
        this.fields[fieldKey].properties.accept = info.fileType.mimes
        this.fields[fieldKey].properties.multiple = info.multiple
        this.fields[fieldKey].properties.fileTypeId = info.fileType.id
        this.fields[fieldKey].properties.name = info.name
        this.fields[fieldKey].properties.label = info.description
        this.fields[fieldKey].properties.required = info.required
        this.fields[fieldKey].properties.icon = info.fileType.icon
      }
    }

    addOwner () {
      this.formData.owner.push('')
      this.formData.uid.push('')
      this.formData.personType.push('')
    }

    @Watch('formData', { deep: true, immediate: true })
    onFormChange () {
      // Solo validar la forma sin tocar los campos específicos
      this.validateFormBasic()

      // La validación de CAV no debe realizarse en este watcher general
      // ya que provoca un ciclo infinito al modificar formData.cavErrorMessages
      // que a su vez dispara el watcher de formData nuevamente
    }

    // Watch específicos para propiedades individuales que afectan a la validación del CAV
    @Watch('formData.brand.match')
    @Watch('formData.model.match')
    @Watch('formData.version.match')
    @Watch('formData.year')
    @Watch('formData.version.data', { deep: true })
    @Watch('formData.ppu')
    onCavRelatedDataChange () {
      // Si hay datos de CAV, validar las diferencias con los datos seleccionados
      if (this.formData.cavData) {
        this.validateCavDifferences()
      }
    }

    validateCavDifferences () {
      // Si no hay datos del CAV, no hay nada que validar
      if (!this.formData.cavData) return

      // Crear un array para todos los mensajes de error
      const errorMessages = []

      // Validar campos básicos del vehículo
      this.validateBasicCavFields(errorMessages)

      // Validar versión
      this.validateCavVersion(errorMessages)

      // Asignar los mensajes de error actualizados
      if (!this.formData.cavErrorMessages) {
        this.$set(this.formData, 'cavErrorMessages', errorMessages)
      } else {
        this.formData.cavErrorMessages.splice(0, this.formData.cavErrorMessages.length, ...errorMessages)
      }

      // Forzar la actualización del componente
      this.$forceUpdate()
    }

    validateBasicCavFields (errorMessages) {
      // Validar patente
      if (this.formData.cavData.ppuCav && this.formData.ppu &&
          this.formData.cavData.ppuCav !== this.formData.ppu) {
        errorMessages.push(`Patente: CAV=${this.formData.cavData.ppuCav}`)
      }

      // Validar año
      if (this.formData.cavData.year && this.formData.year &&
          this.formData.cavData.year !== this.formData.year.toString()) {
        errorMessages.push(`Año: CAV=${this.formData.cavData.year}`)
      }

      // Validar marca - si hay marca en CAV pero no hay seleccionada o son diferentes
      if (this.formData.cavData.brand &&
          (!this.formData.brand?.match?.name ||
           this.formData.cavData.brand.toLowerCase() !== this.formData.brand.match.name.toLowerCase())) {
        // Marcas diferentes o no seleccionada
        errorMessages.push(`Marca: CAV=${this.formData.cavData.brand}`)
      }

      // Validar modelo - si hay modelo en CAV pero no hay seleccionado o son diferentes
      if (this.formData.cavData.model &&
          (!this.formData.model?.match?.name ||
           (!this.formData.cavData.model.toLowerCase().includes(this.formData.model.match.name.toLowerCase()) &&
            !this.formData.model.match.name.toLowerCase().includes(this.formData.cavData.model.toLowerCase())))) {
        // Modelos diferentes o no seleccionado
        errorMessages.push(`Modelo: CAV=${this.formData.cavData.model}`)
      }
    }

    validateCavVersion (errorMessages) {
      if (!this.formData.cavData || !this.formData.model?.match?.name) return

      let versionToFind = this.formData.cavData.version?.toLowerCase() || ''

      // Si no hay una versión explícita en el CAV, intentar extraerla del modelo
      if (!versionToFind && this.formData.cavData.model) {
        versionToFind = this.extractVersionFromModel(this.formData.cavData.model, this.formData.model.match.name)
      }

      // Si tenemos un nombre de versión para buscar, pero no coincide con la versión seleccionada
      if (versionToFind) {
        const versionMatch = this.findMatchingVersion(versionToFind)
        const hasMatchingVersion = !!versionMatch

        // Solo agregar el error si no hay versión seleccionada o si es diferente
        if (!this.formData.version?.match || !hasMatchingVersion ||
            (this.formData.version?.match?.version?.name &&
             !this.formData.version.match.version.name.toLowerCase().includes(versionToFind) &&
             !versionToFind.includes(this.formData.version.match.version.name.toLowerCase()))) {
          this.suggestedVersion = versionToFind.toUpperCase()
          errorMessages.push(`Versión: CAV=${versionToFind.toUpperCase()}`)
        }
      }
    }

    validateFormBasic () {
      // Validar campos básicos requeridos
      this.isFormValid = !!(
        this.formData.ppu &&
        this.formData.year &&
        this.formData.brand.match &&
        this.formData.model.match &&
        this.formData.version.match &&
        this.formData.generation &&
        this.formData.acquisitionType &&
        this.formData.date &&
        this.formData.mileage &&
        this.formData.purchasePrice &&
        this.formData.priceList &&
        this.formData.owners
      )

      // Validar que todos los propietarios tengan datos completos
      const ownersValid = this.formData.owner.every((owner, index) =>
        owner &&
        this.formData.uid[index] &&
        this.formData.personType[index]
      )

      this.isFormValid = this.isFormValid && ownersValid
    }

    validatePriceList () {
      // Asegurarse de inicializar el mensaje como vacío
      this.formData.priceListErrorMessage = ''

      if (!this.formData.priceList || !this.formData.purchasePrice) return

      // Validar que el precio de lista no sea menor al precio de compra
      if (parseFloat(this.formData.priceList) < parseFloat(this.formData.purchasePrice)) {
        this.formData.priceListErrorMessage = 'Advertencia: Precio de lista menor al precio de compra'
      }
    }

    validateRenewalBonus () {
      // Limpiar mensajes previos
      this.formData.renewalBonusErrorMessage = ''
      this.formData.renewalBonusWarningMessage = ''

      // Si no hay bono de renovación, no validar
      if (!this.formData.renewalBonus) return

      // Validar que no sea mayor o igual al precio de lista
      if (this.formData.priceList &&
          parseFloat(this.formData.renewalBonus) >= parseFloat(this.formData.priceList)) {
        this.formData.renewalBonusErrorMessage = 'El bono de renovación no puede ser igual o mayor al precio de lista'
        return
      }

      // Validar que no sea menor o igual al descuento (advertencia)
      if (this.formData.discount &&
        parseFloat(this.formData.renewalBonus) < parseFloat(this.formData.discount)) {
        this.formData.renewalBonusWarningMessage = 'El bono de renovación debe ser mayor al descuento'
      }
    }

    validateDiscount () {
      // Limpiar mensajes previos
      this.formData.discountErrorMessage = ''
      this.formData.discountWarningMessage = ''

      // Si no hay descuento, no validar
      if (!this.formData.discount) return

      // Validar que no sea mayor o igual al precio de lista
      if (this.formData.priceList &&
          parseFloat(this.formData.discount) >= parseFloat(this.formData.priceList)) {
        this.formData.discountErrorMessage = 'El descuento no puede ser igual o mayor al precio de lista'
      }

      // Advertencia si el descuento es alto (por ejemplo, más del 10% del precio de lista)
      if (this.formData.priceList &&
          parseFloat(this.formData.discount) >= 0.1 * parseFloat(this.formData.priceList)) {
        this.formData.discountWarningMessage = 'Precaución: el descuento es alto en relación al precio de lista'
      }
    }

    get getPriceListErrorMessage () {
      if (!this.formData.priceList) {
        return 'Campo requerido'
      }
      return ''
    }

    get getMileageWarningMessage () {
      if (!this.formData.mileage) {
        return ''
      }

      const digits = String(this.formData.mileage).length

      if (digits < 4) {
        return 'Precaución: bajo kilometraje'
      } else if (digits > 5) {
        return 'Precaución: mucho kilometraje'
      }

      return ''
    }

    get getRenewalBonusErrorMessage () {
      return this.formData.renewalBonusErrorMessage || ''
    }

    // Datos para la tabla de propietarios
    get getOwnersTableData () {
      return this.formData.owner.map((name, index) => ({
        name,
        uid: this.formData.uid[index],
        type: this.formData.personType[index],
      }))
    }

    async validatePlate () {
      const plate = this.formData.ppu?.toUpperCase()
      if (!plate || plate?.length < 6) return

      // Verificar si la patente ya existe en el sistema
      const result = await this.fetchData({
        query: { name: 'find', model: 'Auto' },
        filter: {
          _and: [
            { registration_plate: { _eq: plate } },
            { process_status: { status: { name: { _in: ['buying', 'enabling', 'selling', 'reserved', 'reservation_process', 'available'] } } } },
          ],
        },
        force: true,
      })

      if (Array.isArray(result) && result.length > 0) {
        this.plateAlert.title = `La patente "${plate}" ya existe en el sistema con estado: ${result[0]?.status?.description}`
        this.plateAlert.open = true
      }
    }

    async handleYearChange () {
      // Limpiar marca, modelo y versión
      this.formData.brand.match = null
      this.formData.brand.data = []
      this.formData.model.match = null
      this.formData.model.data = []
      this.formData.version.match = null
      this.formData.version.data = []
      this.formData.idGeneration = null
      this.formData.idVersionYear = null

      // Cargar marcas para el año seleccionado
      if (this.formData.year) {
        await this.fetchBrands()

        // Al cambiar el año, validar inmediatamente las diferencias con CAV
        if (this.formData.cavData) {
          await this.$nextTick()
          this.validateCavDifferences()
        }
      }
    }

    async fetchBrands () {
      // Obtener las marcas disponibles para este año
      this.formData.brand.data = await this.fetchData({
        query: { name: 'findLite', model: 'Brand', order: { name: 'asc' } },
        filter: {
          models: {
            versions: {
              years: {
                id_year: {
                  _gte: parseToNumber(this.formData.year) - parseToNumber(this.maxVehicleAgeAllowed),
                  _lte: parseToNumber(this.formData.year) + parseToNumber(this.maxVehicleAgeAllowed),
                },
              },
            },
          },
        },
        force: true,
      })
    }

    async handleBrandChange () {
      // Limpiar modelo y versión
      this.formData.model.match = null
      this.formData.model.data = []
      this.formData.version.match = null
      this.formData.version.data = []

      // Buscar modelos para la nueva marca
      if (this.formData.brand.match && this.formData.year) {
        await this.fetchModels()
      }

      // Validar diferencias con el CAV si es necesario
      if (this.formData.cavData) {
        this.validateCavDifferences()
      }
    }

    async fetchModels () {
      this.formData.model.data = await this.fetchData({
        query: {
          name: 'findLite',
          model: 'Model',
          order: {
            name: 'asc',
          },
        },
        filter: {
          _and: [
            { id_brand: { _eq: this.formData.brand.match?.id } },
            {
              versions: {
                years: {
                  id_year: {
                    _gte: parseToNumber(this.formData.year),
                    _lte: parseToNumber(this.formData.year),
                  },
                },
              },
            },
          ],
        },
        force: true,
      })
    }

  async handleModelChange () {
      // Limpiar versión
      this.formData.version.match = null
      this.formData.version.data = []
      this.formData.idGeneration = null
      this.formData.idVersionYear = null

      // Buscar versiones para el nuevo modelo
      if (this.formData.model.match && this.formData.year) {
        await this.fetchVersions()
      }

      // Validar diferencias con el CAV si es necesario
      if (this.formData.cavData) {
        this.validateCavDifferences()
      }
    }

    async fetchVersions () {
      this.formData.version.data = await this.fetchData({
        query: {
          name: 'findLite',
          model: 'VersionYear',
          order: {
            id_year: 'desc',
          },
        },
        filter: {
          _and: [
            {
              version: {
                _and: [
                  {
                    model: { _and: [{ id_brand: { _eq: this.formData.brand.match?.id } }, { id: { _eq: this.formData.model.match?.id } }] },
                  },
                ],
              },
            },
            {
              id_year: {
                _gte: parseToNumber(this.formData.year) - parseToNumber(this.maxVehicleAgeAllowed),
                _lte: parseToNumber(this.formData.year) + parseToNumber(this.maxVehicleAgeAllowed),
              },
            },
          ],
        },
        force: true,
      })

      // No es necesario llamar a validateCavDifferences() aquí
      // porque el watcher de formData.version.data lo detectará automáticamente
    }

    handleVersionChange () {
      // Actualizar idVersionYear con el nuevo ID de versión
      if (this.formData.version?.match?.id) {
        this.formData.idVersionYear = this.formData.version.match.id
      }

      // Activar la actualización de atributos
      this.formData.checkAttributes = true

      // Validar diferencias con el CAV si es necesario
      if (this.formData.cavData) {
        this.validateCavDifferences()
      }
    }

    async onCavFileChange () {
      if (!this.formData.cav?.length) return

      try {
        const fileInfo = await this.fetchData({
          query: { name: 'fetch', model: 'File', params: { id: this.formData.cav[0].id } },
          force: true,
        })

        const isSerialization = 'serialization' in fileInfo && fileInfo?.serialization
        if (!isSerialization) {
          this.cavAlert.title = 'No se pudo leer el CAV intente nuevamente'
          this.cavAlert.open = true
          return
        }

        const isCavInfo = 'cavInfo' in isSerialization && isSerialization?.cavInfo
        const carData = 'carData' in isCavInfo && isCavInfo.carData

        // Guardar los datos del carData para validaciones
        if (carData) {
          this.formData.cavData = carData
          this.formData.cavSerialization = isSerialization
          // Auto-completar campos con los datos del CAV
          await this.autoFillFromCav(carData)
        }

        // Procesar propietarios del CAV
        const currOwners = 'currOwners' in isCavInfo && isCavInfo.currOwners
        this.formData.owners = isCavInfo?.prevOwners?.length ? isCavInfo?.prevOwners?.length + 1 : 1

        if (currOwners && currOwners.length) {
          // Limpiar arreglos de propietarios actuales
          this.formData.owner = []
          this.formData.uid = []
          this.formData.personType = []

          // Procesar cada propietario del CAV
          await Promise.all(
            currOwners.map(async owner => {
              let person = null
              // Buscar si la persona ya existe
              const existingPersons = await this.fetchData({
                query: { name: 'find', model: 'Person' },
                filter: { uid: { _ilike: `%${owner.rutClean}%` } },
                force: true,
              })

              if (existingPersons && existingPersons.length) {
                // Si existe, retornar la persona existente
                person = existingPersons[0]
              } else {
                // Los datos de la persona se manejarán en la vista principal
                person = {
                  fullName: owner.isNaturalPerson
                    ? `${owner.firstName || ''} ${owner.secondName || ''} ${owner.surname || ''} ${owner.secondSurname || ''}`.trim()
                    : owner.companyName || owner.alias || '',
                  uid: owner.rutClean,
                  type: { description: owner.isNaturalPerson ? 'Persona Natural' : 'Empresa' },
                }
              }

              this.formData.owner.push(person.fullName)
              this.formData.uid.push(person.uid)
              this.formData.personType.push(person.type.description)
            }),
          )
        }
      } catch (error) {
        console.error('Error procesando archivo CAV:', error)
        this.cavAlert.title = 'Error al procesar el archivo CAV'
        this.cavAlert.open = true
      }
    }

    async autoFillFromCav (carData) {
      if (!carData) return

      // Auto-completar patente
      if (carData.ppuCav && !this.formData.ppu) {
        this.formData.ppu = carData.ppuCav
        await this.validatePlate()
      }

      // Auto-completar año
      if (carData.year && !this.formData.year) {
        const yearMatch = this.years.find(y => y.id.toString() === carData.year.toString())
        if (yearMatch) {
          this.formData.year = yearMatch.id
          await this.handleYearChange()
        }
      }

      // Completar marca, modelo y versión si están disponibles
      await this.autoFillVehicleDetails(carData)
    }

    async autoFillVehicleDetails (carData) {
      // Esperar a que se carguen las marcas
      if (carData.brand && this.formData.brand.data.length > 0 && !this.formData.brand.match) {
        const brandMatch = this.formData.brand.data.find(b =>
          b.name.toLowerCase() === carData.brand.toLowerCase()
        )

        if (brandMatch) {
          this.formData.brand.match = brandMatch
          await this.handleBrandChange()

          // Completar modelo y versión
          await this.autoFillModelAndVersion(carData)
        }
      }
    }

    async autoFillModelAndVersion (carData) {
      // Esperar a que se carguen los modelos
      if (carData.model && this.formData.model.data.length > 0 && !this.formData.model.match) {
        const modelMatch = this.formData.model.data.find(m => {
          const modelName = m.name.toLowerCase()
          const cavModelName = carData.model.toLowerCase()
          return modelName === cavModelName ||
                 modelName.includes(cavModelName) ||
                 cavModelName.includes(modelName)
        })

        if (modelMatch) {
          this.formData.model.match = modelMatch
          await this.handleModelChange()

          // Buscar versión usando el método auxiliar
          await this.findAndSetVersion(carData, modelMatch)
        }
      }
    }

    async findAndSetVersion (carData, modelMatch) {
      // Verificar si hay versión explícita en CAV o debe extraerse del modelo
      let versionToFind = carData.version?.toLowerCase() || ''

      // Si no hay una versión explícita en el CAV, intentar extraerla del modelo
      if (!versionToFind && carData.model) {
        versionToFind = this.extractVersionFromModel(carData.model, modelMatch.name)
      }

      // Intentar encontrar la versión correcta
      if (versionToFind && this.formData.version.data.length > 0 && !this.formData.version.match) {
        this.matchVersionFromCav(versionToFind)
      }
    }

    extractVersionFromModel (cavModelText, selectedModelName) {
      const modelName = selectedModelName.toLowerCase()
      const cavModelName = cavModelText.toLowerCase()

      // Si el modelo CAV contiene al modelo seleccionado, extraer la parte restante
      if (cavModelName.includes(modelName) && cavModelName !== modelName) {
        const remainingPart = cavModelName.replace(modelName, '').trim()

        // Guardar esta información para usarla en caso de que se necesite crear una versión
        if (remainingPart) {
          this.suggestedVersion = remainingPart
          return remainingPart
        }
      }

      return ''
    }

    copyToClipboardAndNotify (text, tipo) {
      // Copiar al portapapeles
      navigator.clipboard.writeText(text)
        .then(() => {
          // Notificar al usuario
          this.loadNotification({
            message: `Valor de ${tipo} CAV copiado: ${text}`,
            color: 'success',
          })
        })
        .catch(err => {
          console.error('Error al copiar al portapapeles:', err)
          this.errorAlert.title = `No se pudo copiar el valor de ${tipo} CAV`
          this.errorAlert.open = true
        })
    }

    copyToClipboardVersion () {
      // Extraer el valor correcto según la fuente
      let versionText = ''

      if (this.formData.cavErrorMessages && this.formData.cavErrorMessages.some(msg => msg.includes('Versión:'))) {
        // Si hay un mensaje de error específico para versión, extraer el valor
        const versionMsg = this.formData.cavErrorMessages.find(msg => msg.includes('Versión:'))
        versionText = versionMsg?.split('CAV=')[1]?.split(',')[0] || ''
      } else if (this.formData.cavData && this.formData.cavData.version) {
        // Si no hay mensaje pero hay version en cavData
        versionText = this.formData.cavData.version
      }

      if (versionText) {
        this.copyToClipboardAndNotify(versionText, 'versión')
      }
    }

    resetForm () {
      this.formData = _.cloneDeep({
        cav: [],
        ppu: null,
        year: null,
        brand: {
          match: null,
          data: [],
        },
        model: {
          match: null,
          data: [],
        },
        version: {
          match: null,
          data: [],
        },
        traction: { value: '' },
        transmission: { value: '' },
        fuel: { value: '' },
        owner: [],
        personType: [],
        uid: [],
        acquisitionType: null,
        date: null,
        key: '',
        keyErrorMessage: '',
        mileage: null,
        owners: null,
        purchasePrice: null,
        priceList: null,
        discount: null,
        renewalBonus: null,
        renewalBonusErrorMessage: '',
        renewalBonusWarningMessage: '',
        priceListErrorMessage: '',
        discountErrorMessage: '',
        discountWarningMessage: '',
        generation: null,
        checkAttributes: true,
        idVersionYear: null,
        idGeneration: null,
        cavData: null,
        cavErrorMessages: [],
        id: this.getGenerateRandomKey(),
      })
    }

    @Emit('edited')
    emitEdited (formData) {
      return formData
    }

    async send () {
      const renewalError = this.formData.renewalBonusWarningMessage
      if (!this.$refs.form.validate() || !this.isFormValid || this.hasErrors || this.formData.cavData.ppuCav !== this.formData.ppu || renewalError?.length) {
        await this.setFieldError()
        return
      }

      this.loadingForm = true

      try {
        // Asegurar que la versión esté configurada
        await this.prepareItemVersion(this.formData)

        // Construir y enviar los datos al servidor
        const recordData = this.buildRecordData([this.formData])

        // Actualizar JWT antes de la llamada
        await updateJWT()
        const token = localStorage.getItem('apollo-token')

        // Enviar datos al endpoint
        const { VUE_APP_BASE_URL } = process.env
        await axios.post(`${VUE_APP_BASE_URL}/geniofiles/api/stock/upload-records`, recordData, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          timeout: 30000,
        })

        // Mostrar mensaje de éxito
        this.successAlert.title = `El vehículo ${this.formData.ppu} ha sido importado correctamente`
        this.successAlert.open = true

        // Si es edición, emitir evento 'edited', si no, resetear el formulario y emitir 'created'
        this.$emit('created', this.formData)
        this.$emit('close-dialog')
        this.resetForm()
      } catch (error: any) {
        console.error('Error al agregar registro:', error)
        this.errorAlert.title = `Error al importar el registro: ${error.message || 'Error desconocido'}`
        this.errorAlert.open = true
      } finally {
        this.loadingForm = false
      }
    }

    // Métodos para manejar la creación de versiones
    openCreateVersionDialog () {
      this.showCreateVersionDialog = true
    }

    onVersionCreated (data) {
      // Actualizar el formulario con la versión recién creada
      if (data && data.version && data.versionYear) {
        // Actualizar versión y versionYear
        this.updateWithVersionYear(data.versionYear, data.version)
      } else if (data && data.version) {
        // Buscar versionYear para la versión creada
        this.fetchVersionYear(data.version)
      }

      // Cerrar el diálogo después de crear la versión
      this.showCreateVersionDialog = false

      // No es necesario llamar a validateCavDifferences() aquí
      // porque los watchers detectarán los cambios automáticamente
    }

    updateWithVersionYear (versionYear, version) {
      // Asegurarse de que version.data existe
      if (!this.formData.version.data) {
        this.formData.version.data = []
      }

      // Agregar la versión encontrada a las versiones disponibles si no existe
      if (!this.formData.version.data.some(v => v.id === versionYear.id)) {
        this.formData.version.data.push(versionYear)
      }

      // Actualizar la versión seleccionada
      this.formData.version.match = versionYear
      this.formData.idVersionYear = versionYear.id

      // Establecer generación si está disponible
      if (versionYear.generation && versionYear.generation.id) {
        this.formData.generation = versionYear.generation
        this.formData.idGeneration = versionYear.generation.id
      } else {
        this.formData.idGeneration = null
      }

      // Forzar el evento checkAttributes para que se actualicen los atributos
      this.formData.checkAttributes = true

      // No es necesario llamar a validateCavDifferences() aquí
      // porque los watchers detectarán los cambios automáticamente

      // Notificar al usuario
      this.loadNotification({
        message: `Versión ${version.name} seleccionada correctamente`,
        color: 'success',
      })
    }

    async fetchVersionYear (version) {
      if (!version || !version.id || !this.formData.year) {
        console.error('Datos insuficientes para buscar VersionYear')
        return
      }

      // Obtener los datos de VersionYear para el año específico
      const versionYearData = await this.fetchData({
        query: {
          name: 'findLite',
          model: 'VersionYear',
        },
        filter: {
          _and: [
            { id_version: { _eq: version.id } },
            { id_year: { _eq: this.formData.year } },
          ],
        },
        force: true,
      })

      if (versionYearData && versionYearData.length > 0) {
        this.updateWithVersionYear(versionYearData[0], version)
      } else {
        // Si no se encuentra el VersionYear, intentar extender la versión para el año
        // Creamos un objeto temporal con la estructura esperada por extendVersionToSelectedYear
        const tempItem = {
          year: this.formData.year,
          version: {
            match: {
              id: null,
              version,
            },
          },
          idVersionYear: null,
          idGeneration: null,
          checkAttributes: true,
        }

        // Asignar el ID de versión correctamente
        tempItem.version.match.version.id = version.id

        try {
          // Usar el método de la clase base para extender la versión
          const newVersionYear = await this.extendVersionToSelectedYear(tempItem)
          if (newVersionYear) {
            // Actualizar nuestro formulario con la versión extendida
            this.updateWithVersionYear(newVersionYear, version)
          }
        } catch (error: any) {
          console.error('Error al extender versión:', error)
          this.errorAlert.title = error.message || 'Error al extender la versión'
          this.errorAlert.open = true
        }
      }
    }

    // Propiedades computadas para el componente CreateVersion
    get versions () {
      const modelId = this.formData.model?.match?.id
      if (!modelId) return []

      // Filtrar las versiones disponibles para este modelo
      return this.formData.version.data
        ?.filter(v => v.version)
        ?.map(v => v.version)
        ?.filter((v, i, self) => i === self.findIndex(t => t.name === v.name && t.id === v.id)) || []
    }

    async prepareItemVersion (item) {
      // Verificar si la versión ya existe para el año seleccionado
      const versionYearExists = await this.checkVersionYearExists(item)

      if (!versionYearExists) {
        // Si no existe, extenderla desde una versión existente en otro año
        await this.extendVersionToSelectedYear(item)
      }

      // Verificar y asegurar que idVersionYear esté establecido correctamente
      if (item?.version?.match?.id) {
        item.idVersionYear = item.version.match.id
      }
    }

  async checkVersionYearExists (item) {
      // Si no hay versión seleccionada, no hay nada que verificar
      if (!item.version?.match?.id) return false

      // Consultar si existe la versión para el año seleccionado
      const resultVersionYear = await this.fetchData({
        query: { name: 'fetch', model: 'VersionYear', params: { id: item.version.match.id } },
        force: true,
      })

      const resultVersion = (await this.fetchData({
        query: { name: 'find', model: 'Version' },
        filter: {
          id: { _eq: resultVersionYear.version.id },
        },
        force: true,
      }))[0]

      const result = await this.fetchData({
        query: { name: 'find', model: 'VersionYear' },
        filter: {
          _and: [
            { id_version: { _eq: resultVersion.id } },
            { id_year: { _eq: item.year } },
          ],
        },
        force: true,
      })

      return Boolean(Array.isArray(result) && result.length)
    }

    get change () {
      return stringifySafe([this.formData])
    }

    @Watch('formData.cav', { deep: true, immediate: true })
    onCavChange () {
      this.onCavFileChange()
    }

    closeAlert () {
      this.alert.open = false
      this.alert.title = ''
    }

    handlePlateAlertConfirm () {
      this.formData.ppu = ''
      this.plateAlert.open = false
      this.plateAlert.title = ''
      this.resetForm()
    }

    handleCavAlertConfirm () {
      this.cavAlert.open = false
      this.cavAlert.title = ''
    }

    async handleSuccessAlertConfirm () {
      this.successAlert.open = false
      this.successAlert.title = ''
      this.$emit('close-dialog')
      this.resetForm()

      this.redirectToImport(true)
      this.$refs.form.reset()
      await this.fillKeys()
    }

    async handleSuccessAlertCancel () {
      this.successAlert.open = false
      this.successAlert.title = ''
      this.resetForm()
      this.$refs.form.reset()
      await this.fillKeys()
    }

    handleErrorAlertConfirm () {
      this.errorAlert.open = false
      this.errorAlert.title = ''
    }

    shouldShowCavDifference (field) {
      // Si no hay datos de CAV, no hay diferencias que mostrar
      if (!this.formData.cavData) return false

      // Verificar si hay mensajes de error para este campo específico
      if (this.formData.cavErrorMessages && this.formData.cavErrorMessages.length > 0) {
        const fieldPrefix = field === 'ppu' ? 'Patente:'
          : field === 'year' ? 'Año:'
          : field === 'brand' ? 'Marca:'
          : field === 'model' ? 'Modelo:'
          : field === 'version' ? 'Versión:'
          : ''

        if (fieldPrefix && this.formData.cavErrorMessages.some(msg => msg.includes(fieldPrefix))) {
          return true
        }
      }

      // Si no hay errores en cavErrorMessages, usar la lógica original
      switch (field) {
        case 'ppu':
          // Mostrar si el CAV tiene valor pero el campo no, o si son diferentes
          return (
            this.formData.cavData.ppuCav && (
              !this.formData.ppu ||
              this.formData.cavData.ppuCav !== this.formData.ppu
            )
          )

        case 'year':
          return (
            this.formData.cavData.year && (
              !this.formData.year ||
              this.formData.cavData.year !== this.formData.year.toString()
            )
          )

        case 'brand':
          return (
            this.formData.cavData.brand && (
              !this.formData.brand?.match?.name ||
              this.formData.cavData.brand.toLowerCase() !== this.formData.brand.match.name.toLowerCase()
            )
          )

        case 'model':
          return (
            this.formData.cavData.model && (
              !this.formData.model?.match?.name ||
              (!this.formData.cavData.model.toLowerCase().includes(this.formData.model.match.name.toLowerCase()) &&
              !this.formData.model.match.name.toLowerCase().includes(this.formData.cavData.model.toLowerCase()))
            )
          )

        case 'version':
          return this.shouldShowVersionDifference()

        default:
          return false
      }
    }

    // Método auxiliar para verificar diferencias en versiones
    shouldShowVersionDifference () {
      // Si hay versión explícita en CAV
      if (this.formData.cavData.version) {
        // Si hay versión seleccionada, compararlas
        if (this.formData.version?.match?.version?.name) {
          const versionName = this.formData.version.match.version.name.toLowerCase()
          const cavVersion = this.formData.cavData.version.toLowerCase()

          // Si las versiones coinciden o si una contiene a la otra, no mostrar diferencia
          if (versionName === cavVersion || versionName.includes(cavVersion) || cavVersion.includes(versionName)) {
            return false
          }
        }
        // Si no hay versión seleccionada o son diferentes, mostrar diferencia
        return true
      }

      // Verificar si hay mensajes de error específicos de versión
      if (this.formData.cavErrorMessages?.some(msg => msg.includes('Versión:'))) {
        // Verificar si la versión seleccionada coincide con la del mensaje de error
        const versionErrorMsg = this.formData.cavErrorMessages.find(msg => msg.includes('Versión:'))
        const cavVersionInError = versionErrorMsg?.split('CAV=')[1]?.split(',')[0]?.toLowerCase()

        if (cavVersionInError && this.formData.version?.match?.version?.name) {
          const versionName = this.formData.version.match.version.name.toLowerCase()

          // Si coinciden, eliminar el mensaje de error y no mostrar diferencia
          if (versionName === cavVersionInError || versionName.includes(cavVersionInError) || cavVersionInError.includes(versionName)) {
            this.formData.cavErrorMessages = this.formData.cavErrorMessages.filter(msg => !msg.includes('Versión:'))
            return false
          }
        }
        return true
      }

      // Extraer posible versión del modelo
      return this.checkVersionInModel()
    }

    // Método auxiliar para encontrar versiones coincidentes
    findMatchingVersion (versionToFind) {
      return this.formData.version.data.find(v => {
        const versionName = v.version?.name?.toLowerCase() || ''
        return versionName === versionToFind ||
               versionName.includes(versionToFind) ||
               versionToFind.includes(versionName)
      })
    }

    // Método auxiliar para verificar si hay versión en el nombre del modelo
    checkVersionInModel () {
      if (!this.formData.cavData.model || !this.formData.model?.match?.name) {
        return false
      }

      const modelName = this.formData.model.match.name.toLowerCase()
      const cavModelName = this.formData.cavData.model.toLowerCase()

      // Si el modelo CAV no incluye al modelo seleccionado o son iguales, no hay diferencia
      if (!cavModelName.includes(modelName) || cavModelName === modelName) {
        return false
      }

      const remainingPart = cavModelName.replace(modelName, '').trim()

      // Si no hay parte restante, no hay diferencia
      if (!remainingPart) {
        return false
      }

      // Si hay versión seleccionada, verificar si coincide con la parte restante
      if (this.formData.version?.match?.version?.name) {
        const versionName = this.formData.version.match.version.name.toLowerCase()

        // Si la versión seleccionada contiene la parte restante o viceversa, no hay diferencia
        if (versionName.includes(remainingPart) || remainingPart.includes(versionName)) {
          return false
        }
      }

      // Si no coinciden, mostrar diferencia
      return true
    }

    getCavFieldStatus (field) {
      if (!this.formData.cavData) return ''

      // Primero buscar si hay un mensaje de error específico para este campo
      if (this.formData.cavErrorMessages && this.formData.cavErrorMessages.length > 0) {
        const fieldPrefix = field === 'ppu' ? 'Patente:'
          : field === 'year' ? 'Año:'
          : field === 'brand' ? 'Marca:'
          : field === 'model' ? 'Modelo:'
          : field === 'version' ? 'Versión:'
          : ''

        if (fieldPrefix) {
          const errorMsg = this.formData.cavErrorMessages.find(msg => msg.includes(fieldPrefix))
          if (errorMsg) {
            return errorMsg
          }
        }
      }

      // Si no hay mensaje de error, usar la lógica original
      switch (field) {
        case 'ppu':
          return this.formData.cavData.ppuCav ? `CAV: ${this.formData.cavData.ppuCav}` : 'Campo no presente en CAV'
        case 'year':
          return this.formData.cavData.year ? `CAV: ${this.formData.cavData.year}` : 'Campo no presente en CAV'
        case 'brand':
          return this.formData.cavData.brand ? `CAV: ${this.formData.cavData.brand}` : 'Campo no presente en CAV'
        case 'model':
          return this.formData.cavData.model ? `CAV: ${this.formData.cavData.model}` : 'Campo no presente en CAV'
        case 'version':
          return this.getVersionFieldStatus()
        default:
          return 'Campo no presente en CAV'
      }
    }

    getVersionFieldStatus () {
      // Verificar si hay un mensaje de error específico para versión
      const versionFromError = this.formData.cavErrorMessages &&
        this.formData.cavErrorMessages.find(msg => msg.includes('Versión:'))?.split('CAV=')[1]?.split(',')[0]

      if (versionFromError) {
        return `CAV: ${versionFromError}`
      }

      // Verificar si hay una versión explícita en CAV
      if (this.formData.cavData.version) {
        return `CAV: ${this.formData.cavData.version.toUpperCase()}`
      }

      // Extraer versión del modelo si está disponible
      if (this.formData.cavData.model && this.formData.model?.match?.name) {
        const modelName = this.formData.model.match.name.toLowerCase()
        const cavModelName = this.formData.cavData.model.toLowerCase()

        if (cavModelName.includes(modelName) && cavModelName !== modelName) {
          const remainingPart = cavModelName.replace(modelName, '').trim()
          if (remainingPart) {
            return `CAV: ${remainingPart.toUpperCase()} (extraído del modelo)`
          }
        }
      }

      return 'Campo no presente en CAV'
    }

    closeDialog () {
      this.resetForm()
      this.$refs.form.reset()
      this.$emit('close-dialog')
    }

    // Métodos para manejar eventos de input
    handlePriceListInput () {
      // Solo ejecutar validaciones, el v-model ya actualiza el valor
      this.validatePriceList()
      this.validateDiscount()
      this.validateRenewalBonus()
    }

    handleDiscountInput () {
      this.validateDiscount()
      this.validateRenewalBonus()
    }

    handleRenewalBonusInput () {
      this.validateRenewalBonus()
    }

    beforeDestroy () {
      this.resetForm()
      this.$refs.form.reset()
    }

    @Watch('cleanForm', { immediate: true })
    onCleanFormChange (newVal) {
      if (newVal) {
        this.resetForm()
      }
    }

  @Watch('formData.key', { immediate: true, deep: true })
  @Debounce(1000)
  onKeyChange (newVal) {
    this.displaySii = true
    if (!newVal) return
    this.formData.keyErrorMessage = ''
    const isBusyKey = this.keysAvailable.find(key => key.id === newVal && !key.name.includes('Disponible'))

    if (isBusyKey) {
      this.formData.keyErrorMessage = 'La llave ya está en uso'
    } else {
      this.formData.keyErrorMessage = ''
    }
  }

  matchVersionFromCav (versionToFind) {
    // Utilizar el método compartido para encontrar una versión coincidente
    const versionMatch = this.findMatchingVersion(versionToFind)

    if (versionMatch) {
      this.formData.version.match = versionMatch
      this.handleVersionChange()
    } else if (versionToFind) {
      // Si no se encontró la versión pero tenemos un nombre sugerido,
      // almacenarlo para posible creación manual
      this.suggestedVersion = versionToFind.toUpperCase()

      // La actualización de errores se manejará en validateCavDifferences
      // que será llamado por los watchers cuando formData.version.match cambie
    }
  }
  }
